import React, { useEffect } from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import { useDispatch, useSelector } from "react-redux";
import { getResourceAPI, postResource } from "../../redux/slices/resourceSlice";
import {
  getUIData,
  getUIProperty,
  setUIData,
} from "../../redux/slices/uiSlice";
import CustomCell from "../generic/CustomCell";
import { toCustomDate } from "../../utils/date";
import notify from "devextreme/ui/notify";
import { tabNameToPath } from "../../utils/strings";
import useResources from "../../hooks/useResources";
import Loader from "../generic/Loader";
import { useState } from "react";

const TabCreateModal = ({
  setVisible,
  visible,
  cells,
  tabName,
  formatData,
  reduxName,
  vessel_id,
}) => {
  const dispatch = useDispatch();

  const data = useSelector((state) => getUIData(state, reduxName));
  const { tradeCases } = useResources();
  const [loading, setLoading] = useState(false);

  const selectedTradeCaseId = useSelector((state) =>
    getUIProperty(state, "selectedTradeCaseId")
  );

  useEffect(() => {
    if (tradeCases instanceof Array && vessel_id) {
      const data = cells.reduce((acc, cell) => {
        const { dataField, defaultValue } = cell;
        return { ...acc, [dataField]: defaultValue };
      }, {});

      dispatch(
        setUIData({
          name: reduxName,
          value: {
            ...data,
            vessel_id,
            selectedTradeCaseId,
            date: toCustomDate(),
          },
        })
      );

      dispatch(
        getResourceAPI({
          path: "vessel-system",
          query: {
            vessel_id,
          },
        })
      );
    }
  }, [
    dispatch,
    selectedTradeCaseId,
    tradeCases,
    tabName,
    reduxName,
    vessel_id,
    cells,
  ]);

  const handlePOST = () => {
    setLoading(true);

    dispatch(
      postResource({
        path: tabNameToPath[tabName],
        data: formatData(data),
      })
    ).then(({ payload }) => {
      setLoading(false);
      if (payload.error) {
        notify(payload.error, "error", 1000);
        return;
      }

      dispatch(
        getResourceAPI({
          path: "search-details",
          query: { trade_case_id: selectedTradeCaseId },
        })
      );
      setVisible(false);
      notify(`Successfully added ${tabNameToPath[tabName]}`, "info", 1000);

      return;
    });
  };

  return (
    <Popup
      visible={!!visible}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title={`Add ${tabNameToPath[tabName]}`}
      container=".dx-viewport"
      width={550}
      height={770}
    >
      {loading && <Loader />}
      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        options={{
          icon: "save",
          text: "Save",
          onClick: handlePOST,
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "Close",
          onClick: () => setVisible(false),
        }}
      />
      {selectedTradeCaseId &&
        cells.map((cell, idx) => {
          return (
            <CustomCell
              key={idx}
              caption={cell.caption}
              dataField={cell.dataField}
              type={cell.type}
              value={data[cell.dataField]}
              reduxName={reduxName}
              resourceName={cell.resourceName}
              resourcePath={cell.resourcePath}
            />
          );
        })}
    </Popup>
  );
};

export default React.memo(TabCreateModal);
